/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/

import { type Point, Vec2 } from './vec2';
import {
  type initiallySelectedType,
  BaseMicromoleculeEntity,
} from 'domain/entities/BaseMicromoleculeEntity';

export interface RxnPlusAttributes {
  pp?: Point;
  initiallySelected?: initiallySelectedType;
}

export class RxnPlus extends BaseMicromoleculeEntity {
  pp: Vec2;

  constructor(attributes?: RxnPlusAttributes) {
    super(attributes?.initiallySelected);
    this.pp = attributes?.pp ? new Vec2(attributes.pp) : new Vec2();
  }

  clone() {
    return new RxnPlus(this);
  }
}
